const colors = {
  background: 'rgb(255,255,255)',
  cardBackground: '#FFFFFF',
  clear: 'rgba(0,0,0,0)',
  transparent: 'rgba(0,0,0,0)',
  silver: '#F7F7F7',
  veryLightSilver: '#EEEEEF',
  lightSilver: '#E4E2E2',
  darkRed: 'rgb(169,0,0)',
  steel: '#CCCCCC',
  error: 'rgba(200, 0, 0, 0.8)',
  ricePaper: 'rgba(255,255,255, 0.75)',
  frost: '#D8D8D8',
  cloud: 'rgba(200,200,200, 0.35)',
  windowTint: 'rgba(0, 0, 0, 0.4)',
  panther: '#161616',
  charcoal: '#595959',
  coal: '#2d2d2d',
  bloodOrange: '#fb5f26',
  snow: 'white',
  ember: 'rgba(164, 0, 48, 0.5)',
  fire: '#e73536',
  drawer: 'rgba(30, 30, 29, 0.95)',
  eggplant: '#251a34',
  banner: '#5F3E63',
  text: '#E0D7E5',
  darkRedTwo: '#820000',
  red: 'rgb(255,0,0)',
  vfRed: '#E60000',
  vfRedRGBA: (alpha = 1) => `rgba(230, 0, 0, ${alpha})`,
  vfGrey: '#4A4D4E',
  vfLightGrey: 'rgb(186,186,186)',
  border: '#dddddd',
  white: 'rgb(255, 255, 255)',
  offWhite: 'rgb(244,244,244)',
  whiteRGBA: (alpha = 1) => `rgba(255, 255, 255, ${alpha})`,
  brownGrey: '#7e7e7e',
  ocean: '#00697C',
  lightOcean: 'rgb(0, 176, 202)',
  oceanRGBA: (alpha = 1) => `rgba(0, 124, 146, ${alpha})`,
  veryLightPink: 'rgb(204, 204, 204)',
  mustardGreen: 'rgb(168, 182, 0)',
  mustardGreenRGBA: (alpha = 1) => `rgba(168, 182, 0, ${alpha})`,
  darkGrassGreen: 'rgb(66, 134, 0)',
  darkGrassGreenRGBA: (alpha = 1) => `rgba(66, 134, 0, ${alpha})`,
  marigold: 'rgb(254, 203, 0)',
  marigoldRGBA: (alpha = 1) => `rgba(254, 203, 0, ${alpha})`,
  tangerine: 'rgb(235, 151, 0)',
  tangerineRGBA: (alpha = 1) => `rgba(235, 151, 0, ${alpha})`,
  brownGreyTwo: 'rgb(151, 151, 151)',
  veryLightPinkTwo: 'rgb(235, 235, 235)',
  overlay: 'rgba(0,0,0,0.6)',
  veryLightPinkTwoRGBA: (alpha = 1) => `rgba(235, 235, 235,${alpha})`,
  babyBlue: 'rgb(0, 22, 230)',
  babyBlueRGBA: (alpha = 1) => `rgba(0, 22, 230, ${alpha})`,
  babyBlue2: 'rgb(0, 22, 255)',
  babyBlue2RGBA: (alpha = 1) => `rgba(0, 22, 255, ${alpha})`,
  babyBlue3: '#007aff',
  whiteSmoke: '#f4f4f4',
  shadow: 'rgba(0, 0, 0, 0.2)',
  lightShadow: 'rgba(0, 0,0, 0.16)',
  darkShadow: 'rgba(0, 0,0, 0.5)',
  lightGrey: 'rgb(200,200,200)',
  lightGreyTwo: 'rgb(125,125,125)',
  veryLightGrey: '#d3d3d3',
  veryLightGreyTwo: '#9B9B9B',
  veryLightGreyThree: '#A1A1A1',
  linegrey: 'rgba(0, 0, 0, 0.16)',
  activeRed: 'rgb(153, 0, 0)',
  activeGrey: 'rgb(244, 244, 244)',
  icGreyStep: 'rgba(0, 0, 0, 0.5)',
  black: '#000000',
  warm_grey_two: '#999999',
  whisper: '#eeeeee',
  thickWhisper: '#DFDFDF',
  white_two: '#BEBEBE',
  lightGrayTwo: 'rgb(229, 229, 229)',
  success: 'rgb(0, 153, 0)',
  blackRGBA: (alpha = 1) => `rgba(0, 0, 0, ${alpha})`,
  fresh_orange: '#EB9700',
  maroon: '#990000',
  light_grey: '#666666',
  very_light_grey: '#CCCCCC',
  smoothGrey: '#4A4D4E',
  smoothGreyTwo: 'rgb(58,58,58)',
  thinDark: 'rgb(51,51,51)',
  sharpBlack: 'rgb(15,0,0)',
  dark_grey: '#0D0D0D',
  dark_grey_2: '#25282B',
  dark_grey_3: 'rgb(86, 86, 86)',
  very_dark_grey: '#464646',
  blackTwo: 'rgb(51,51,51)',
  blackTwoRGBA: (alpha = 1) => `rgba(51, 51, 51, ${alpha})`,
  blackThree: '#222222',
  blackFour: 'rgb(34,34,34)',
  charcoalGrey: 'rgb(74, 77, 78)',
  charcoalGreyTwo: 'rgb(74, 74, 74)',
  platinum: 'rgb(175, 175, 175)',
  pearl: '#FEFFFE',
  pearlTwo: '#FAFAFA',
  dove: '#434345',
  mine: '#474747',
  blue_two: '#007c92',
  blue_three: '#00b0ca',
  success_two: '#a8b400',
  true_green: '#009900',
  light_green: '#7ed321',
  light_black: 'rgb(113,113,113)',
  fresh_orangeTwo: 'rgb(231, 144, 0)',
  turquoise: 'rgb(0, 150, 174)',
  darkCyan: 'rgb(0, 124, 146)',
  warmPurpleTwo: 'rgb(156, 42, 160)',
  coral: 'rgb(240, 102, 102)',
  warm_grey: 'rgb(113, 113, 113)',
  light_warm_grey: 'rgb(157, 157, 157)',
  mono5: '#262626',
  secondary5: '#008a00',
  secondary7: '#BD0000',
  blue_magenta: '#6200EE',
  dark_shade_grey: '#353535',
  mono2: '#F2F2F2',
  mono3: '#bebebe',
  mono6: '#0d0d0d',
  dark_orange: '#eb6100',
  primaryRed: '#EA1A1A',
  secondaryRed: '#E60000',
  secondary7_inverse: '#F06666',
};

export default colors;
